/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-access-state-in-setstate */

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledTooltip } from "reactstrap";
import { faCopy, faDownload } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";

function BackapCodeModal({ toggle, isOpen, backupCode }) {
  // revisar y ajustar el formato de backup code

  const backup = backupCode && typeof backupCode === "string" ? backupCode : "Código no disponible.";

  const handleCopyBackupCode = () => {
    try {
      navigator.clipboard.writeText(backupCode);
      toast.success("Codigo copiado!");
    } catch (error) {
      toast.error(`Error al copiar el codigo ${error}`);
    }
  };

  const handleDownloadBackupCode = () => {
    try {
      const fileName = "codigo_de_respaldo.txt";
      const element = document.createElement("a");
      const file = new Blob([backupCode], { type: "text/plain" });
      element.href = URL.createObjectURL(file);
      element.download = fileName;
      element.click();
      URL.revokeObjectURL(element.href);
      toast.success("Codigo descargado!");
    } catch (error) {
      toast.error(`Error al descargar el codigo ${error}`);
    }
  };

  return (
    <div>
      <Modal isOpen={isOpen} toggle={toggle} centered>
        <ModalHeader className="border-0 pb-0" toggle={toggle} />
        <ModalBody className="pt-0 pb-0">
          <>
            <div className="p-2 w-100 d-flex flex-column justify-content-center ">
              <h5 className="badge-pills mt-4" style={{ fontSize: "18px" }}>
                Código de respaldo
              </h5>
              <p className="badge-pills h-50 w-100 justify-content-center" style={{ fontSize: "14px", fontWeight: "normal", padding: "10px 0" }}>
                Éste es tu nuevo código de respaldo, el cual reemplaza tu código anterior. Guardalo en un lugar seguro
              </p>
              <div className="d-flex flex-column align-items-center justify-content-center rounded p-4  mx-auto" style={{ borderRadius: "8px", background: "#F7F7F7" }}>
                <div className="d-flex justify-content-around align-items-center">
                  <p className="m-1 text-center" style={{ fontSize: "14px", fontWeight: "bold" }}>
                    {backup}
                  </p>
                </div>
                <div>
                  <UncontrolledTooltip placement="left" target="btnCopy">
                    copiar
                  </UncontrolledTooltip>
                  <FontAwesomeIcon
                    id="btnCopy"
                    onClick={handleCopyBackupCode}
                    icon={faCopy}
                    className="m-2"
                    color="var(--primary)"
                    style={{ cursor: "pointer" }}
                    size="lg"
                  />
                  <UncontrolledTooltip placement="right" target="btnDownload">
                    Descargar
                  </UncontrolledTooltip>
                  <FontAwesomeIcon
                    id="btnDownload"
                    onClick={handleDownloadBackupCode}
                    icon={faDownload}
                    className="m-2"
                    color="var(--primary)"
                    style={{ cursor: "pointer" }}
                    size="lg"
                  />
                </div>
              </div>
            </div>
          </>
        </ModalBody>
        <ModalFooter className="border-0 pt-0">
          <Button color="btn btn-primary" onClick={toggle}>
            Finalizar
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default BackapCodeModal;
